const areaData = (name, expected, given, error, entry = false, candid_id = 0, kline_ids = [], no_aligner = '', no_aligner_co = 0) => {
    return {
        name            : name,
        expected        : expected,
        given           : given,
        error           : error,
        entry           : entry,
        candid_id       : candid_id,
        kline_ids       : kline_ids,
        no_aligner      : no_aligner === '' ? given : no_aligner,
        no_aligner_co   : no_aligner_co === 0 ? candid_id : no_aligner_co
    };
}

module.exports = {
    AREAS: {
        D3          : areaData('3D Print'   , '3D Processing'       , 'Spray Init'          , '3D Error'        , false , 1,    [8,9,10,11]),
        SPRAY       : areaData('Spray'      , 'Spray Init'          , 'Machining Init'      , 'Spray Error'     , false , 4,    [12,13,14], 'Biostar Init', 2), 
        BIOSTAR     : areaData('BioStar'    , 'Biostar Init'        , 'Machining Init'      , 'Biostar Error'   , false , 3,    [15,16,17]),
        MTC         : areaData('MTC'        , 'MTC Init'            , 'Laser Init'          , 'MTC Error'       , false , 6,    [21,22,23]),
        MACHINING   : areaData('Machining'  , 'Machining Init'      , 'Laser Init'          , 'Machining Error' , false , 6,    [18,19,20]),
        LASER       : areaData('Laser'      , 'Laser Init'          , 'Tumbler Init'        , 'Laser Error'     , false , 6,    [24,25,26]),
        TUMBLER     : areaData('Tumbler'    , 'Tumbler Init'        , 'Polish Init'         , 'Tumbler Error'   , false , 7,    [27,28,29]),
        POLISH      : areaData('Polish'     , 'Polish Init'         , 'Packaging Init'      , 'Polish Error'    , false , 7.1,  [30,31,32,33,34,35,36]),
        PACKAGING   : areaData('Packaging'  , 'Packaging Init'      , 'Shipping Init'       , 'Packaging Error' , false , 9,    [37,38,39]),
        SHIPING     : areaData('Shipping'   , 'Shipping Init'       , 'Shipping Complete'   , 'Shipping Error'  , false , 9.1,  [40,41,42,43,44,45]),
    },
    TRACING_AREAS: {
        D3          : areaData('3D Print'   , '', '', '', false , 0     , [8,9,10,11]),
        SPRAY       : areaData('Spray'      , '', '', '', false , 1     , [12,13,14]), 
        BIOSTAR     : areaData('BioStar'    , '', '', '', false , 2     , [15,16,17]),
        MTC         : areaData('MTC'        , '', '', '', false , 3     , [21,22,23]),
        MACHINING   : areaData('Machining'  , '', '', '', false , 4     , [18,19,20]),
        LASER       : areaData('Laser'      , '', '', '', false , 5     , [24,25,26]),
        TUMBLER     : areaData('Tumbler'    , '', '', '', false , 6     , [27,28,29]),
        POLISH      : areaData('Polish'     , '', '', '', false , 7     , [30,31,32]),
        QAPOLISH    : areaData('QA Polish'  , '', '', '', false , 7.1   , [33,34,35]),
        MRB         : areaData('MRB'        , '', '', '', false , 7.5   , [36]),
        PACKAGING   : areaData('Packaging'  , '', '', '', false , 8     , [37,38,39]),
        SHIPING     : areaData('Shipping'   , '', '', '', false , 9     , [40,41,42]),
        QASHIPING   : areaData('QA Shipping', '', '', '', false , 9.1   , [43,44,45]),
    },
    AREA_TABS:{
        '3D Print' : '3D',
        Spray      : undefined,
        BioStar    : undefined,
        MTC        : 'MTC3',
        Machining  : 'Attlas',
        Laser      : undefined,
        Tumbler    : 'Tumbler',
        Polish     : 'Pulido',
        Packaging  : undefined,
        Shipping   : undefined
    }
}